/**
 * Pipeline board & velocity, and §61 loss analysis — `docs/API.md` §6.
 *
 * Separate top-level paths from `/opportunities` (`GET /pipeline/board`,
 * `GET /pipeline/velocity`, `GET /analytics/lost-opportunities`), matching
 * how `salescrmapi` mounts them: `pipeline.routes.js` and
 * `analytics.routes.js`, not opportunity sub-resources.
 */
import apiClient from './axiosClient.js';
import { withMockFallback } from './mockFallback.js';

/** @param {{pipeline_id?:string, owner_id?:string, team_id?:string, close_date_from?:string, close_date_to?:string, limit_per_stage?:number}} [params] */
export function getPipelineBoard(params = {}) {
  return withMockFallback(
    'GET /pipeline/board',
    async () => (await apiClient.get('/pipeline/board', { params })).data,
    () => ({ pipeline: null, columns: [], totals: { count: 0, amount: 0, weighted: 0 } }),
  );
}

/** @param {{pipeline_id?:string, from?:string, to?:string, owner_id?:string, team_id?:string}} [params] */
export function getPipelineVelocity(params = {}) {
  return withMockFallback(
    'GET /pipeline/velocity',
    async () => (await apiClient.get('/pipeline/velocity', { params })).data,
    () => ({ period: {}, stages: [], overall: { win_rate_pct: 0, avg_sales_cycle_days: null, avg_deal_size: null } }),
  );
}

/** @param {{from?:string, to?:string, group_by?:string}} [params] */
export function getLostOpportunities(params = {}) {
  return withMockFallback(
    'GET /analytics/lost-opportunities',
    async () => (await apiClient.get('/analytics/lost-opportunities', { params })).data,
    () => ({ period: {}, total_lost: { count: 0, value: 0 }, by_reason: [], by_competitor: [], lost_by_stage: {} }),
  );
}
